import { useEffect, useState } from 'react';
import { TiTick } from 'react-icons/ti';
import { useSearchParams } from 'react-router-dom';
import { FormPersonalData } from '../form-curso/FormPersonalData';
import { FormBilling } from '../form-carrera/FormBilling';
import { SelectPayment } from '../SelectPayment';
import { SignDocument } from '../SignDocument';
import { SimpleFinishPayment } from '../SimpleFinishPayment';
import axios, { AxiosError } from 'axios';
import { useDispatch } from 'react-redux';
import { updateData } from '../../../../store/slices/userDataFormSlice';
import { WelcomeSection } from '../WelcomeSection';

export const FormReintegro = () => {
  const steps = [
    'Bienvenida',
    'Datos personales',
    'Documento a emitir',
    'Forma de pago',
    'Firma de acuerdo',
    'Finalizar pago'
  ];

  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [dataUser, setDataUser] = useState<any>([]);
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [paymentMethodSelected, setPaymentMethodSelected] = useState('');
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDataUser();
    localStorage.setItem('type_form', 'registro_reintegro');
    localStorage.setItem('register_id', String(params.get('register')));
    localStorage.setItem('token_user_latam', String(params.get('token')));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDataUser = async () => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_BACKEND}/registers/${params.get(
          'register'
        )}/form`,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${params.get('token')}`
          }
        }
      )
      .then((response: any) => {
        // console.log('Response User =>', response.data);
        setDataUser(response.data);
        setCurrentStep(response.data[0].step);
        dispatch(updateData(response.data[0]));
      })
      .catch((error: AxiosError) => {
        console.log('Error fetchDataUser =>', error);
        setError(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <div className="flex justify-between">
          {steps?.map((step, index) => (
            <div
              key={index}
              className={`step-item ${currentStep === index + 1 && 'active'} ${
                (index + 1 < currentStep || complete) && 'complete'
              }`}
            >
              <p className="text-gray-500">{step}</p>
              <div className="step">
                {index + 1 < currentStep || complete ? (
                  <TiTick size={24} />
                ) : (
                  index + 1
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {(() => {
        if (loading) {
          return <span>Cargando...</span>;
        } else {
          if (!error) {
            switch (currentStep) {
              case 1:
                return (
                  <WelcomeSection
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    dataUser={dataUser[0]}
                  />
                )
              case 2:
                return (
                  <FormPersonalData
                    registerId={String(params.get('register'))}
                    token={String(params.get('token'))}
                    dataUser={dataUser[0]}
                    currentStep={currentStep}
                    setComplete={setComplete}
                    setCurrentStep={setCurrentStep}
                    stepsLength={steps.length}
                  />
                );
              case 3:
                return (
                  <FormBilling
                    registerId={String(params.get('register'))}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                  />
                );
              case 4:
                return (
                  <SelectPayment
                    registerId={String(params.get('register'))}
                    token={String(params.get('token'))}
                    prices={[dataUser[0].price]}
                    dataUser={dataUser[0]}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    paymentSelected={setPaymentMethodSelected}
                    tuition={dataUser[0].price.tuition}
                    tuitionExempted={dataUser[0].tuition_exempted}
                    discount={dataUser[0].discount}
                    allianceDiscount={dataUser[0].alliance_discount}
                    totalDiscountPercentage={dataUser[0].total_discount_percentage}
                    variantApplication={dataUser[0].variant_application}
                  />
                );
              case 5:
                return (
                  <SignDocument
                    currentStep={currentStep}
                    paymentMethod={paymentMethodSelected}
                    setCurrentStep={setCurrentStep}
                  />
                );
              case 6:
                return (
                    <SimpleFinishPayment
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        dataUser={dataUser[0]}
                        suppliers={dataUser[0].supplier ? [{ id: 0, description: dataUser[0].supplier }] : []}
                    />
                );
              default:
                break;
            }
          } else {
            return (
              <div className="text-center font-bold w-100 py-40">
                <p>El link de acceso ha expirado o ha sido cancelado, por favor contacta a <b>inscripciones@desafiolatam.com</b></p>
              </div>
            );
          }
        }
      })()}
    </div>
  );
};
